import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../../base-url';

const API_URL = baseUrl()+"/api/all/";

const getAnggotaUmum = 'anggota-umum';
const postAnggotaUmumUrl = 'anggota-umum';
const putAnggotaUmum = 'anggota-umum/';
const deleteAnggotaUmum = 'anggota-umum/';
const exportAnggotaUmum = ''
const sendInvoice = 'anggota-umum-invoice'
const getDokumenAnggotaUmum = 'anggota-umum/dokumen-pendukung-peserta-dan-master/';
const verifikasiDataDokumen = 'data-keanggotaan/data-dokumen-pendukung/verifikasi'
const getDokumenPendukungAnggotaUmum = 'dokumen-pendukung-anggota-umum-peserta/'

class AnggotaUmumService {
    getAnggotaUmum(currentPage,pageSize,filter,filterKategori) {
        return axios.get(API_URL + getAnggotaUmum, 
        {
            params: {
                pageNo: currentPage,
                pageSize: pageSize,
                sortBy: 'id',
                filter: filter,
                filterKategori: filterKategori
            },
            headers: authHeader()
        });
    }

    sendInvoice(formData) {
        return axios
        .post(
            API_URL + sendInvoice,
            formData,
            { headers: authHeader() }
        );
    }

    postAnggotaUmum(formData) {        
        return axios
        .post(
            API_URL + postAnggotaUmum,
            formData,
            { headers: authHeader() }
        );
    }

    putAnggotaUmum(formData) {    
        return axios.put(API_URL + putAnggotaUmum + formData.id_anggota_umum, {
            statusPersyaratan: formData.status_persyaratan,
            alasan: formData.alasan,
        },
            { headers: authHeader() }
        );
    }

    exportAnggotaUmum() {
        return axios.get(API_URL + exportAnggotaUmum, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

    deleteAnggotaUmum(id) {
        return axios.delete(API_URL + deleteAnggotaUmum + id, {
            headers: authHeader()
        });
    }

    getDokumenAnggotaUmum(id) {
        return axios.get(API_URL + getDokumenAnggotaUmum + id, {
            headers: authHeader()
        });
    }

    getDokumenPendukungAnggotaUmum(id) {
        return axios.get(API_URL + getDokumenPendukungAnggotaUmum + id, {
            headers: authHeader()
        });
    }

    verifikasiDataDokumen(formData) {
        var data = {
            idDokumenPendukungPeserta: formData.idDokumenPendukungPeserta,
            statusUpload: formData.statusUpload
        }
        return axios.post(API_URL + verifikasiDataDokumen, data, {
            headers: authHeader()
        });
    }

}

export default new AnggotaUmumService();